import React, { useState, useCallback, useMemo } from "react";
import Toolbar, { Item } from "devextreme-react/toolbar";
import Button from "devextreme-react/button";
import UserPanel from "../user-panel/user-panel";
import "../user-panel/user-panel.scss";
import "./header.scss";
import { Template } from "devextreme-react/core/template";
import { useAuth } from "../../contexts/auth";

export default function ({ menuToggleEnabled, title, toggleMenu }) {
  const { user } = useAuth();
  const [useNewVersion, setUseNewVersion] = useState(
    () => localStorage.getItem("use_new_form") === "true"
  );

  // Detect current route to show the right label
  const isOnNewVersion = useMemo(() => {
    const hash = window.location.hash || "";
    return hash.includes("/form") && !hash.includes("/test-form");
  }, []);

  const toggleVersion = useCallback(() => {
    const hash = window.location.hash || "";
    const onOldForm = hash.includes("#/test-form");
    const onNewForm = hash.includes("#/form") && !hash.includes("#/test-form");
    const onFormPage = onOldForm || onNewForm;

    // Save form data to memory before navigating (registered by TestForm.jsx)
    if (onFormPage) {
      window.__saveFormDraft?.();
    }

    setUseNewVersion(prev => {
      const next = !prev;
      localStorage.setItem("use_new_form", String(next));
      window.dispatchEvent(new StorageEvent("storage", {
        key: "use_new_form",
        newValue: String(next),
      }));

      if (next && onOldForm) {
        window.location.hash = hash.replace("#/test-form", "#/form");
      } else if (!next && onNewForm) {
        window.location.hash = hash.replace("#/form", "#/test-form");
      }

      return next;
    });
  }, []);

  function renderLabel() {
    return (
      <div className="header-logo-wrap">
        <img
          src={user.user.avatarUrl || ""}
          alt="Logo"
          className="header-logo"
          onError={(e) => { e.target.style.display = "none"; }}
        />
      </div>
    );
  }

  function renderVersionToggle() {
    const isNew = useNewVersion;
    return (
      <button
        className={`version-chip ${isNew ? "version-chip--new" : "version-chip--classic"}`}
        onClick={toggleVersion}
        title={isNew ? "לחץ לחזור לגרסה הקלאסית" : "לחץ לנסות את הגרסה החדשה"}
      >
        <span className="version-chip__dot" />
        <span className="version-chip__label">
          {isNew ? "גרסה חדשה" : "גרסה קלאסית"}
        </span>
        <svg className="version-chip__arrow" width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4.5 2.5L8 6L4.5 9.5"/>
        </svg>
      </button>
    );
  }

  return (
    <header className="header-component">
      <Toolbar className="header-toolbar">
        <Item
          visible={menuToggleEnabled}
          location="before"
          widget="dxButton"
          cssClass="menu-button"
        >
          <Button icon="menu" stylingMode="text" onClick={toggleMenu} />
        </Item>
        <Item
          location="before"
          cssClass="header-title"
          text={title}
          visible={!!title}
        />
        <Item location="before" locateInMenu="never">
          {renderVersionToggle()}
        </Item>
        <Item
          location="center"
          locateInMenu="never"
          render={renderLabel}
          cssClass="header-logo-item"
        />
        <Item
          location="after"
          locateInMenu="auto"
          menuItemTemplate="userPanelTemplate"
        >
          <Button
            className="user-button authorization"
            width={210}
            height="100%"
            stylingMode="text"
          >
            <UserPanel menuMode="context" />
          </Button>
        </Item>
        <Template name="userPanelTemplate">
          <UserPanel menuMode="list" />
        </Template>
      </Toolbar>
    </header>
  );
}
